import type { ReferenceObjectResolver } from './types';

const CONFLUENCE_CONTENT_ARI_PATTERN = /^ari:cloud:confluence:([^:]+):(blogpost|page)\/([^/]+)$/;

const isSupportedContentType = (contentType: string): contentType is 'blogpost' | 'page' =>
	contentType === 'blogpost' || contentType === 'page';

export const getConfluenceReferenceObject: ReferenceObjectResolver = ({
	cloudId,
	contentType = 'page',
	contextIdentifierProvider,
	objectId = contextIdentifierProvider?.objectId,
	product = contextIdentifierProvider?.product,
}) => {
	if (!objectId) {
		return undefined;
	}

	const match = CONFLUENCE_CONTENT_ARI_PATTERN.exec(objectId);
	if (!match) {
		if (!cloudId || product !== 'confluence' || !isSupportedContentType(contentType)) {
			return undefined;
		}

		return {
			cloudId,
			referenceObjectAri: `ari:cloud:confluence:${cloudId}:${contentType}/${objectId}`,
		};
	}

	return {
		cloudId: match[1],
		referenceObjectAri: objectId,
	};
};
